











































































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { debounce } from 'debounce';

import { MobileGetter } from 'frontend/types';

@Component({
  computed: {
    ...mapState('numUsers', ['num_users']),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class LandingFooter extends Vue {
  private isMobile!: MobileGetter;
  private screenWidth = 1250;
  private debouncedHandleResize = debounce(this.handleResize, 50);

  private get isNarrowScreen(): boolean {
    return this.isMobile(this.$mq) || this.screenWidth <= 1200;
  }

  private handleResize(): void {
    this.screenWidth = document.body.offsetWidth;
  }

  private mounted(): void {
    this.handleResize();
    window.addEventListener('resize', this.debouncedHandleResize);
  }

  private destroyed(): void {
    window.removeEventListener('resize', this.debouncedHandleResize);
  }
}
